"use client";
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = 2026;

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const footerLinks = [
    { id: 'footer_home', label: 'الرئيسية', href: 'home' },
    { id: 'footer_about', label: 'من نحن', href: 'about' },
    { id: 'footer_services', label: 'خدماتنا', href: 'services' },
    { id: 'footer_contact', label: 'تواصل معنا', href: 'contact' },
  ];

  return (
    <footer className="border-t-2 border-slate-700 py-16 px-8 bg-slate-900" dir="rtl">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12">
          {/* Company Info */}
          <div className="flex flex-col gap-4 text-right flex-1">
            <button
              onClick={() => scrollToSection('home')}
              className="flex items-center gap-3 justify-start cursor-pointer mb-2"
            >
              <div className="flex flex-col items-start gap-[3px] py-1">
                <div className="w-3 h-[1.5px] bg-primary rounded-full"></div>
                <div className="w-2 h-[1.5px] bg-primary/70 rounded-full"></div>
                <div className="w-4 h-[1.5px] bg-primary rounded-full"></div>
              </div>
              <span className="font-cairo text-lg font-bold text-white tracking-[0.1em]">
                شركة الأنيق المتميز
              </span>
            </button>
            <p className="font-cairo text-base text-slate-300 max-w-md leading-relaxed">
              شركة ليبية متخصصة في استيراد وسائل النقل وملحقاتها من مصادر موثوقة
            </p>
            
            {/* Contact Info */}
            <div className="flex flex-col gap-3 mt-4">
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-3 justify-start">
                  <Icon name="PhoneIcon" size={20} className="text-primary" />
                  <span className="font-cairo text-base text-slate-300">أرقام التواصل:</span>
                </div>
                <a
                  href="tel:+218918000071"
                  className="font-cairo text-base text-slate-300 hover:text-primary transition-colors pr-8"
                >
                  <span dir="ltr">0918000071</span>
                </a>
                <a
                  href="tel:+218928000071"
                  className="font-cairo text-base text-slate-300 hover:text-primary transition-colors pr-8"
                >
                  <span dir="ltr">0928000071</span>
                </a>
              </div>
              <a
                href="mailto:alaneeqmutamayyiz@gmail.com"
                className="font-inter text-base text-slate-300 hover:text-primary transition-colors flex items-center gap-3 justify-start"
              >
                <Icon name="EnvelopeIcon" size={20} className="text-primary" />
                alaneeqmutamayyiz@gmail.com
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-col gap-6 items-start md:items-end flex-1">
            <h3 className="font-cairo text-lg font-bold text-white mb-2">روابط سريعة</h3>
            <div className="flex flex-col gap-4 text-base text-slate-300 font-medium font-cairo">
              {footerLinks?.map((link) => (
                <button
                  key={link?.id}
                  onClick={() => scrollToSection(link?.href)}
                  className="hover:text-primary transition-colors cursor-pointer text-right"
                >
                  {link?.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-slate-700">
          <p className="font-cairo text-base text-slate-400 text-center">
            © {currentYear} جميع الحقوق محفوظة - شركة الأنيق المتميز
          </p>
        </div>
      </div>
    </footer>
  );
}